import React, { useState, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import MapBox from "./MapBox";
import GoogleMapRoute from "./GoogleMapRoute";
const DetailsMap = ({bookingObj,mapRoute}) => {
  // const length=Object.keys(props.tripDetails).length
  const [mapFlag, setMapFlag] = useState(false);
  // const [position,setPostion] = useState([51.505, -0.09])
  // const positionInfos=[{address:'Kempegowda International Airport.'},{address:'Lalbagh'}]
  // useEffect(()=>{
  //     setInterval(() => {
  //         setPostion(preValue=>[preValue[0]+0.001,preValue[1]])
  //     }, 1000);
  // },[])

  return (
    <Card className="map-details">
      {/* {mapFlag} */}
      <CardBody className="p-0">
        {/* <div className="custom-toggle-switch">
          <input
            type="checkbox"
            onChange={(e) => {
              setMapFlag(!mapFlag);
            }}
            id="switch"
          />
          <label htmlFor="switch"></label>
        </div> */}

        {/* <div class="custom-control custom-switch">
  <input type="checkbox" class="custom-control-input" id="customSwitch1"/>
  <label class="custom-control-label" for="customSwitch1">Toggle this switch element</label>
</div>
<div class="custom-control custom-switch">
  <input type="checkbox" class="custom-control-input" disabled id="customSwitch2"/>
  <label class="custom-control-label" for="customSwitch2">Disabled switch element</label>
</div> */}
        {/* <MapContainer style={{ height: "100%", width: "100%" }} zoom={13} scrollWheelZoom={false}>
  <TileLayer
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  />
 <LeafletControlGeocoder positionInfos={positionInfos} />
</MapContainer> */}
        {mapFlag ? <GoogleMapRoute bookingObj={bookingObj} />:<MapBox bookingObj={bookingObj} mapRoute={mapRoute}/>}
      </CardBody>
    </Card>
  );
};

export default DetailsMap;
